import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/img/gfx-contact.jpg'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" width=\"970\" height=\"252\"><div id=\"main-content\"><h1>Contact Us</h1><h2>Moksha Enterprises </h2><p>Postnet suite 126 private bag x7 sea point 8060</p><p> t: +27 21 438 1204 <br> f: 086 541 5406<br></p><p> e: <a href=\"mailto:info@moksha.biz\">info@moksha.biz</a> <br><a href=\"http://www.moksha.biz/\">www.moksha.biz</a></p></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _hoisted_1
}